import React, { useEffect, useState, useCallback } from 'react';
import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  deleteDoc,
  doc
} from 'firebase/firestore';
import { db } from '../utils/firebaseConfig';
import { useNavigate } from 'react-router-dom';
import GeneralNavbar from './GeneralNavbar';
import './EmployeeList.css';

const PAGE_SIZE = 10;

function ClientList() {
  const [clients, setClients] = useState([]);
  const [lastDoc, setLastDoc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState('');
  const navigate = useNavigate();

  const fetchClients = useCallback(async (reset = false) => {
    setLoading(true);
    try {
      let baseQuery = query(
        collection(db, 'users'),
        where('role', '==', 'cliente'),
        orderBy('name'),
        limit(PAGE_SIZE)
      );

      if (!reset && lastDoc) {
        baseQuery = query(baseQuery, startAfter(lastDoc));
      }

      const snapshot = await getDocs(baseQuery);
      const newClients = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      if (reset) {
        setClients(newClients);
      } else {
        setClients(prev => [...prev, ...newClients]);
      }

     if (snapshot.docs.length < PAGE_SIZE) {
        setLastDoc(null); // No hay más clientes para cargar
      } else {
        const lastVisible = snapshot.docs[snapshot.docs.length - 1];
        setLastDoc(lastVisible);
      }

    } catch (err) {
      console.error('Error cargando clientes:', err);
    }
    setLoading(false);
  }, [lastDoc]); // si depende de estados como `lastDoc`

  useEffect(() => {
  fetchClients(true);
}, [fetchClients]);


  const handleEdit = (id) => navigate(`/admin/clients/edit/${id}`);

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de que quieres eliminar este cliente?')) {
      await deleteDoc(doc(db, 'users', id));
      setClients(prev => prev.filter(cli => cli.id !== id));
    }
  };

  const handleBack = () => navigate('/admin/');

  const filteredClients = clients.filter(cli =>
    (cli.name?.toLowerCase() || '').includes(filter.toLowerCase()) ||
    (cli.apellido?.toLowerCase() || '').includes(filter.toLowerCase()) ||
    (cli.email?.toLowerCase() || '').includes(filter.toLowerCase())
  );

  return (
    <>
      <GeneralNavbar title="Lista de Clientes" onBackClick={handleBack} />
      <div className="employee-list" style={{ marginTop: '80px' }}>
        <div style={{ marginBottom: '16px', textAlign: 'center' }}>
          <input
            type="text"
            placeholder="Buscar por nombre, apellido o email"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            style={{ padding: '8px', width: '90%', maxWidth: '400px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
        </div>
        <ul>
          {filteredClients.map(cli => (
            <li key={cli.id}>
              <div className="employee-info">
                {cli.name} {cli.apellido} - {cli.email} - "Cliente"
              </div>
              <div className="employee-actions">
                <button onClick={() => handleEdit(cli.id)}>Editar</button>
                <button onClick={() => handleDelete(cli.id)}>Eliminar</button>
              </div>
            </li>
          ))}
        </ul>
        {lastDoc && !loading && (
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <button onClick={() => fetchClients()}>Cargar más</button>
          </div>
        )}
        {!lastDoc && !loading && clients.length > 0 && (
          <p style={{ textAlign: 'center', color: '#666' }}>No hay más clientes para mostrar.</p>
        )}

        {loading && <p style={{ textAlign: 'center' }}>Cargando...</p>}
      </div>
    </>
  );
}

export default ClientList;

